/**
 * FIXTURE CONDITION SELECTOR
 * 
 * Radio button group for selecting fixture condition:
 * N/A | Keep | Replace | Add New
 */

import React from 'react';
import { FIXTURE_CONDITIONS } from '../../constants/fixtureDefinitions';

const FixtureConditionSelector = ({ value, onChange, disabled = false }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {FIXTURE_CONDITIONS.map(condition => {
        const isSelected = value === condition.value;
        
        let colorClasses = 'border-slate-700 bg-slate-900 text-slate-400';
        if (isSelected) {
          switch (condition.color) {
            case 'slate':
              colorClasses = 'border-slate-500 bg-slate-500/20 text-slate-300';
              break;
            case 'blue':
              colorClasses = 'border-blue-500 bg-blue-500/20 text-blue-400';
              break;
            case 'amber':
              colorClasses = 'border-amber-500 bg-amber-500/20 text-amber-400';
              break;
            case 'emerald':
              colorClasses = 'border-emerald-500 bg-emerald-500/20 text-emerald-400';
              break;
            default:
              colorClasses = 'border-slate-500 bg-slate-500/20 text-slate-300';
          }
        }
        
        return (
          <button
            key={condition.value}
            type="button"
            onClick={() => !disabled && onChange(condition.value)}
            disabled={disabled}
            className={`
              px-3 py-1.5 text-xs font-medium border rounded transition-all
              ${colorClasses}
              ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-slate-500'}
            `}
          >
            {condition.label}
          </button>
        );
      })}
    </div>
  );
};

export default FixtureConditionSelector;
